export default __webpack_public_path__ + "static/media/HUD-Effects-05.c3d417e2.jpg";